"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var FeaturedTemplateThumbnail_1 = require("TemplatesGallery/TemplateThumbnail/FeaturedTemplateThumbnail");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var FeaturedTemplatesData_1 = require("TemplatesGallery/FeaturedTemplatesData");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Configuration_1 = require("Styles/Configuration/Configuration");
var FeaturedTemplatesPreview_1 = require("TemplatesGallery/FeaturedTemplatesPreview/FeaturedTemplatesPreview");
var TemplateGhost_1 = require("TemplatesGallery/TemplateThumbnail/TemplateGhost");
var StaggeredAnimation_1 = require("Dashboard/Layout/StaggeredAnimation");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var TemplatesGalleryTelemetry_1 = require("./TemplatesGalleryTelemetry");
var c = (0, BemBuilder_1.default)("grid-gallery");
var PAGE_SIZE = 150;
var ANIMATION_DELAY_MS = 50;
var GridGallery = function (props) {
    var _a;
    var selectedCategory = props.selectedCategory, apiBaseUrl = props.apiBaseUrl, modalService = props.modalService, searchTerm = props.searchTerm, onboarding = props.onboarding, pageCreationHelper = props.pageCreationHelper;
    var _b = __read((0, react_1.useState)(Types_1.TEMPLATES_FIRST_PAGE), 2), page = _b[0], setPage = _b[1];
    var _c = __read((0, react_1.useState)([]), 2), cachedTemplates = _c[0], setCachedTemplates = _c[1];
    (0, react_1.useEffect)(function () {
        setPage(Types_1.TEMPLATES_FIRST_PAGE);
        setCachedTemplates([]);
    }, [selectedCategory]);
    var featuredTemplates = (0, FeaturedTemplatesData_1.useFeaturedTemplates)(apiBaseUrl, {
        searchTerm: searchTerm,
        page: page,
        pageSize: PAGE_SIZE,
        category: selectedCategory,
    }).featuredTemplates;
    var incrementPage = function () {
        setCachedTemplates(__spreadArray(__spreadArray([], __read(cachedTemplates), false), [{ data: featuredTemplates.data }], false));
        setPage(page + 1);
    };
    var onCloseHandler = function () {
        modalService.closeAnyModals();
    };
    var previewTemplate = function (template) {
        props.telemetry.previewViewed(template.featuredTemplate._id, TemplatesGalleryTelemetry_1.TemplateGallerySources.FeaturedTemplateThumbnail, selectedCategory);
        modalService.showSimpleModal({
            isEscapable: true,
            containerClassName: "template-preview-modal",
            body: (react_1.default.createElement(kaleidoscope_2.Layer, { offset: Configuration_1.modalZIndex }, function () { return (react_1.default.createElement(FeaturedTemplatesPreview_1.FeaturedTemplatePreview, { template: template, onModalClose: function () {
                    props.telemetry.previewClosed(template.featuredTemplate._id);
                    onCloseHandler();
                }, apiBaseUrl: apiBaseUrl, onboarding: onboarding, pageCreationHelper: pageCreationHelper })); })),
        });
    };
    var renderGhosts = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, __spreadArray([], __read(Array(PAGE_SIZE).keys()), false).map(function (i) { return (react_1.default.createElement(TemplateGhost_1.TemplateGhost, { key: i })); })));
    };
    var renderTemplates = function (data, index) { return (react_1.default.createElement(StaggeredAnimation_1.StaggeredAnimation, { key: "".concat(selectedCategory, "-").concat(index), transitionName: "template-staggered-transition", delayInMs: ANIMATION_DELAY_MS, disableLeaveAnimation: true, transitionTimeoutInMs: kaleidoscope_2.AnimationDuration.Long }, data.map(function (template, index) { return (react_1.default.createElement("div", { className: c("grid-item"), key: index },
        react_1.default.createElement(FeaturedTemplateThumbnail_1.FeaturedTemplateThumbnail, { template: template, onClick: function () { return previewTemplate(template); } }))); }))); };
    var pages = __spreadArray(__spreadArray([], __read(cachedTemplates), false), [{ data: featuredTemplates.data }], false);
    var lastPage = pages[pages.length - 1];
    var totalCount = (0, lodash_1.sumBy)(pages, function (page) { var _a, _b; return (_b = (_a = page.data) === null || _a === void 0 ? void 0 : _a.data.length) !== null && _b !== void 0 ? _b : 0; });
    var allLoaded = (0, lodash_1.every)(pages, function (page) { return !!page.data; });
    var hasNext = lastPage && ((_a = lastPage.data) === null || _a === void 0 ? void 0 : _a.pagination.hasNext);
    return (react_1.default.createElement("div", { className: c() }, allLoaded && totalCount === 0 ? (react_1.default.createElement(kaleidoscope_3.EmptyState, { isDashed: true, title: "We can\u2019t find any templates that match your search within this category." })) : (react_1.default.createElement("div", { className: c("gallery-button-wrapper") },
        react_1.default.createElement("div", { className: c("grid-container") }, pages.map(function (page, index) { return (page.data ? renderTemplates(page.data.data, index) : renderGhosts()); })),
        hasNext && (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: incrementPage }, "Load more templates"))))));
};
exports.default = GridGallery;
